<template>
  <div class="eb-pt-row-login">
    <div class="row justify-content-md-center mt-5">
      <div :class="formContainerClass">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <p class="my-4">
                <b class="h5">Congratulations you're now connected to Facebook.</b>
              </p>
              <p>
                Do you have an existing account to link this to?
              </p>
            </div>
          </div>
          <div class="row justify-content-md-center my-4">
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block primary btn-rounded"
                @click="createAccount"
              >
                No
              </button>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block primary-color driver-button-color btn-rounded gf-driver-button"
                @click="userHasAccount"
              >
                Yes - Login and Link
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FacebookConnect",
  props: {
    accessToken: {
      type: String,
      default: ""
    },
    formContainerClass: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      fromRoute: null
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRoute = from;
    });    
  },
  mounted() {
    this.$nextTick(() => this.$gfLogger.logInfo("FacebookLogin.mounted(), fromRoute:", this.fromRoute));   
    this.$store.commit('setAccessToken', this.accessToken);
    this.$store.commit('setAccountLinkMode', true);
    this.$gfLogger.logInfo("FacebookLogin.mounted(), accessToken: " + this.accessToken);
  },

  methods: {
    userHasAccount() {
      this.$store.commit('setLoginStatus', 'login');

      this.$router.push({
        name: this.fromRoute.name
      });
    },

    createAccount() {
      this.$store.commit('setLoginStatus', 'register');
      this.$router.push({
        name: this.fromRoute.name
      });
    }
  }
};
</script>

<style scoped>
.btn-rounded {
  border-radius: 26px;
}
</style>
